import { useFeatureIsOn } from "@growthbook/growthbook-react";
import { useCompanyHasFunctionality } from "src/Pages/Company/CompanyContext";
import FEATURE_FLAGS from "src/utils/constants/featureFlags";

/**
 *
 * @TODO: Remove during refactor. This is bad, this check should be done in filterNavItemsByAlc.
 * Currently we are doing this 2 times, once here and once in filterNavItemsByAlc.
 * The issue here is ENABLE_PERIOD_SUBSCRIPTION_AND_IDEAL_CAFETERIA which check should be moved to filterNavItemsByAlc.
 * UPDATE: Subscription funcionalities moved to filterNavItemsByAlc.
 */
export default function useExcludeMenuItems() {
  const mbActive = useCompanyHasFunctionality("ENABLE_MYBENEFIT_ACTIVE");

  const prepaidCards = useCompanyHasFunctionality("ENABLE_PREPAID_CARDS");
  const companyEvents = useCompanyHasFunctionality("ENABLE_COMPANY_EVENTS");
  const proposals = useCompanyHasFunctionality("ENABLE_PROPOSALS");
  const totalRewardStatement = useCompanyHasFunctionality(
    "ENABLE_TOTAL_REWARD_STATEMENT"
  );
  const absences = useFeatureIsOn(FEATURE_FLAGS.ABSENCES);
  const organizationStructure = useFeatureIsOn(
    FEATURE_FLAGS.ORGANIZATION_STRUCTURE
  );
  const payrollModule = useFeatureIsOn(FEATURE_FLAGS.PAYROLL_MODULE);

  const excludeIds = [];

  if (!mbActive) excludeIds.push("mybenefit_active");

  if (!prepaidCards) excludeIds.push("prepaidCards");
  if (!companyEvents) excludeIds.push("companyEvents");
  if (!proposals) excludeIds.push("proposals");
  if (!totalRewardStatement) excludeIds.push("totalRewardStatement");
  if (!absences) excludeIds.push("absences");
  if (!organizationStructure) excludeIds.push("organisation_structure");
  if (!payrollModule) excludeIds.push("payroll_module");
  if (!organizationStructure) excludeIds.push("organization_structure");

  return excludeIds;
}
